module.exports = __webpack_public_path__ + "static/media/TW.e2d2694a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TW.svg
// module id = 2281
// module chunks = 7